import buttonTheme from "css/themes/Buttons.css";
import appbarTheme from "css/themes/homePage/appbarTheme.css";
import EventTrackingDispatcher from "dispatchers/event-tracking-dispatcher";
import { bool } from "prop-types";
import React from "react";
import { Link, withRouter } from "react-router-dom";
import Button from "react-toolbox/lib/button";
import COLOURS from "util/colours";
import MenuSearchBar from "./menu-search-bar/MenuSearchBar";

class RightSide extends React.Component {
  static propTypes = {
    lightBackground: bool,
  };

  navigateApply = () => {
    const { history } = this.props;

    EventTrackingDispatcher.track("home_apply_applyButton_navBarButton");

    window.location.href = "/app/apply";
  };

  render() {
    const { lightBackground } = this.props;

    return (
      <div className={appbarTheme.rightWrapper}>
        {/*
        hiding since there is no associated functionality

        <MenuSearchBar
          lightBackground={ lightBackground }
        />
        */}

        <a
          href="/app/login"
          className={appbarTheme.loginLink}
          style={{
            color: lightBackground ? COLOURS.ink : COLOURS.white,
          }}
        >
          Log In
        </a>

        <Button
          onClick={this.navigateApply}
          label="Apply Now"
          className={buttonTheme.greenButton}
          theme={buttonTheme}
          id={appbarTheme.tryFreeButton}
          raised
        />
      </div>
    );
  }
}

export default withRouter(RightSide);
